"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanEnvironment = void 0;
/**
 * Remove environment sub-domain from URL.
 *
 * @public
 * @param {string} hostName - URL host name.
 *
 * @returns {string} Cleaned URL host name.
 *
 * @example
 * ```ts
 * const result = cleanEnvironment('https://enroll.qa.pivothealth.com');
 * console.log(result);
 * // -> 'https://enroll.pivothealth.com'
 * ```
 */
function cleanEnvironment(hostName) {
    return hostName.replace(/(stg|qa|local)\./, '');
}
exports.cleanEnvironment = cleanEnvironment;
//# sourceMappingURL=clean-environment.js.map